export default "__VITE_ASSET__DoVGlO$J__"